import { useNavigate } from "react-router-dom";
import CreateMapScreen from "../_form/create";

export default function CreateLayoutMapsPage() {
  const navigate = useNavigate()
  const onSuccess = () => {
    navigate("/config/layout-maps", {
      replace: true
    })
  }

  const onCancel = () => {
    navigate("/config/layout-maps", {
      replace: true
    })
  }
  return (
    <>
      <CreateMapScreen onSuccess={onSuccess} onCancel={onCancel} />
    </>
  )
}